import React from 'react';

const formatLockedAt = (lockedAt) => {
  if (!lockedAt) {
    return 'Unknown time';
  }

  const date = new Date(lockedAt);
  if (Number.isNaN(date.getTime())) {
    return 'Unknown time';
  }

  return date.toLocaleString();
};

const RecordLockBanner = ({ isLocked, lockedByName, lockedAt }) => {
  if (!isLocked) {
    return null;
  }

  return (
    <div className="w-full mb-4 rounded-md border border-amber-300 bg-amber-50 p-3 text-amber-900">
      <div className="flex items-start gap-2">
        <span aria-hidden="true" className="text-base leading-6">
          🔒
        </span>
        <div>
          <p className="text-sm font-medium">
            This record is currently being edited by {lockedByName || 'another user'}. You are in read-only mode.
          </p>
          <p className="mt-1 text-xs text-amber-800">Locked since {formatLockedAt(lockedAt)}</p>
        </div>
      </div>
    </div>
  );
};

export default RecordLockBanner;
